import React from "react"
import type { GalleryImage } from "./types"
import { getOpenVenuePhotoLabel, getVenuePhotoAlt } from "./types"

const STYLES = {
  button:
    "overflow-hidden cursor-pointer border-0 bg-transparent p-0 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2596fa]",
  image: "h-full w-full object-cover",
} as const

type ImagePreviewProps = {
  photo: GalleryImage
  index: number
  onImageClick: (index: number) => void
  className?: string
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ photo, index, onImageClick, className = "" }) => (
  <button
    type="button"
    className={`${STYLES.button} ${className}`}
    onClick={() => onImageClick(index)}
    aria-label={getOpenVenuePhotoLabel(index)}
  >
    <img src={photo.url} alt={getVenuePhotoAlt(index)} className={STYLES.image} />
  </button>
)

export default ImagePreview
